import { apiClient } from '@/lib/api-client'

export interface ActionValueRow {
  action_id: string
  action_name: string
  action_type: 'task' | 'workflow' | 'outcome'
  agent_id: string
  agent_name: string
  signal_code: string
  signal_name: string
  event_count: number
  revenue_per_unit: number | null
  fte_equivalent: number | null
  total_value: number
  fte_value: number
}

export interface AgentValueSummary {
  agent_id: string
  agent_name: string
  event_count: number
  total_value: number
  fte_value: number
  actions: ActionValueRow[]
}

export interface ValueReceiptsResponse {
  actions: ActionValueRow[]
  agents: AgentValueSummary[]
  summary: {
    total_value: number
    total_fte_value: number
    total_events: number
    agent_count: number
  }
  period: { from: string; to: string }
}

export async function getValueReceipts(params?: {
  from_date?: string
  to_date?: string
  agent_id?: string
  customer_id?: string
}): Promise<ValueReceiptsResponse> {
  const query = params
    ? `?${new URLSearchParams(Object.fromEntries(Object.entries(params).filter(([, v]) => v != null)) as Record<string, string>)}`
    : ''
  const res = await apiClient.get<ValueReceiptsResponse>(
    `/usage/value-receipts${query}`
  )
  return res.data
}
